"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAsData = void 0;
var types_1 = require("../types.js");
var getElemsT_1 = require("./getElemsT.js");
var getFstT_1 = require("./getFstT.js");
var getSndT_1 = require("./getSndT.js");
var unwrapAsData_1 = require("./unwrapAsData.js");
/**
 * undoes the `asData` call
 */
function clearAsData(t) {
    // invalid asData type but not worth to rise an error
    if (t[0] === types_1.PrimType.Lambda ||
        t[0] === types_1.PrimType.Delayed)
        return t;
    // already data
    if (t[0] === types_1.PrimType.Struct ||
        t[0] === types_1.PrimType.Data)
        return t;
    t = (0, unwrapAsData_1.unwrapAsData)(t);
    if (t[0] === types_1.PrimType.Alias) {
        t = (0, types_1.alias)(clearAsData(t[1]), t[2]);
    }
    else if (t[0] === types_1.PrimType.List) {
        var listElemsT = (0, getElemsT_1.getElemsT)(t);
        if (listElemsT[0] === types_1.PrimType.Pair) {
            var fstT = (0, getFstT_1.getFstT)(listElemsT);
            var sndT = (0, getSndT_1.getSndT)(listElemsT);
            t = (0, types_1.list)((0, types_1.pair)(clearAsData(fstT), clearAsData(sndT)));
        }
        else {
            t = (0, types_1.list)(clearAsData(listElemsT));
        }
    }
    return t;
}
exports.clearAsData = clearAsData;
